module.exports = __webpack_public_path__ + "static/img/2838_phase_function_Paper_PointsHejduk_Prediction.f63fd2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2838_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 3arH
// module chunks = 0